import React from "react"
import styled from "styled-components"
import { Container, Row, LeftImage, RightImage } from "./SmallTwoUp.styles"

export const SmallTwoUp = ({ data }) => {
	const leftUrl = data.primary.left_image?.url
	const leftAlt = data.primary.left_image?.alt
	const RightUrl = data.primary.right_image?.url
	const rightAlt = data.primary.right_image?.alt

	return (
		<>
			<Container>
				<Row>
					<LeftImage src={leftUrl} alt={leftAlt} />
					<RightImage src={RightUrl} alt={rightAlt} />
				</Row>
			</Container>
		</>
	)
}
